import React, {useState} from 'react';
import { Grid, Typography } from "@mui/material";
import LabourFee from './LabourFee'
import PaymentDetails from './PaymentDetails'
import Button from '../../../components/Button'
import "./styles.css";

const QuoteSummary = (props) => {
    const [selected, setSelected] = useState(false);

    const handleClick = () => {
        setSelected(true)
        props.handleSetActive(true)
    }
    return (
        <Grid display="flex" flexDirection='column' className="summary">
            <Typography style={{fontSize:'15px', fontWeight:'600', padding:'10px 0px', marginRight:'77%'}}>TOTAL QUOTE SUMMARY</Typography>
            <Grid display='flex' justifyContent='space-around' padding='0% 8%'>
                <LabourFee />
                <PaymentDetails />
            </Grid>
            <Grid display="flex" className="total">
                <Typography style={{fontSize:'12px', fontWeight:'600', color:'#0D5C75'}}>TOTAL payable amount to Service Provider</Typography>
                <Typography style={{fontSize:'12px', fontWeight:'600', color:'#0D5C75'}}>R 94.00</Typography>
            </Grid>
           {!selected && <Grid display="flex" className="button">
                <Typography style={{fontSize:'12px', fontWeight:'600', color:'#009B2A', marginLeft:'-6px'}}>All the payments are done by HO and the Job has been executed successfully</Typography>
                <Grid style={{ }}>
                    <Button
                        color="lightGreen" 
                        opacity="1"
                        name="Mark Job Settled"
                        onClick={handleClick}
                    />
                </Grid>
            </Grid>}
            {selected && <Grid display="flex" flexDirection="column" className="bottom-text">
                <Typography style={{fontSize:'12px', fontWeight:'600', color:'#009B2A'}}>Successfully executed the job at site and marked completed on dd/mm/yy.</Typography>
                <Typography style={{fontSize:'12px', fontWeight:'600', color:'#009B2A'}}>The final settlement to plumber was done on dd/mm/yy</Typography>
            </Grid>}
        </Grid>
    );
};

export default QuoteSummary;